<div class="page-header" style="background: linear-gradient(90deg, #2980B9, #3498DB);">
    <h1 style="display : inline-block;">Modifier intervention</h1>
    <h2 *ngIf="orderNo" style="float : right;margin-top: 30px;">Bon de Commande n° {{orderNo}}</h2>
</div>
<div class="main interventions-theme">
    <app-interventions-form #form name="form" (orderNo)="onOrderChange($event)" [edit]="true"></app-interventions-form>
</div> 